export const normalizeLicensePlate = (number: string): string => number.replace(/\s+/g, '').toUpperCase();
